import { FC } from 'react';
import { Flex, Text, Icon } from '@chakra-ui/react';
import { Wrench } from 'components/Icons/Icons';
const CorporateComingSoon: FC<{ title: string; subTitle: string }> = ({ title, subTitle }) => {
  return (
    <Flex bg="secondary.100" justify="center" align="center" flexDir="column" p="35px" borderRadius="base">
      <Icon as={Wrench} color="secondary.400" w="24px" h="24px" />
      <Text as="h2" fontSize="lgMin" color="secondary.800" fontWeight="500" mt="12px" mb="8px">
        {title}
      </Text>
      <Text color="secondary.700" fontSize="md">
        {subTitle}
      </Text>
    </Flex>
  );
};

export default CorporateComingSoon;
